import type { GlutenSignal } from "../../src/types";
import type { GlutenKind } from "./types-explorer";

export function classify(g: GlutenSignal): GlutenKind {
  if (g.source === "disney") return "marked";
  if (g.source === "inferred") {
    if (g.likelihood === "free") return "free";
    if (g.likelihood === "contains") return "contains";
    return "unknown";
  }
  return "unknown";
}

export function glutenLabel(k: GlutenKind): string {
  switch (k) {
    case "free":
      return "GF";
    case "marked":
      return "GF✓";
    case "unknown":
      return "Ask";
    case "contains":
      return "Wheat";
  }
}

export function glutenLongLabel(k: GlutenKind): string {
  switch (k) {
    case "free":
      return "Naturally gluten-free";
    case "marked":
      return "Restaurant-marked GF";
    case "unknown":
      return "Likely needs to be confirmed";
    case "contains":
      return "Contains gluten";
  }
}
